import { X } from "lucide-react";
import { Button } from "@/components/ui/button";

interface EdgeConfigDrawerProps {
  edge: { id: string; label?: string; data?: Record<string, unknown> };
  onUpdate: (data: { label?: string; condition?: string }) => void;
  onDelete: () => void;
  onClose: () => void;
}

export function EdgeConfigDrawer({ edge, onUpdate, onDelete, onClose }: EdgeConfigDrawerProps) {
  const label = (edge.label as string) ?? "";
  const condition = ((edge.data as Record<string, unknown>)?.condition as string) ?? "";

  return (
    <div className="w-72 shrink-0 border-l border-border bg-card overflow-y-auto">
      <div className="flex items-center justify-between px-4 py-3 border-b border-border">
        <h3 className="text-xs font-semibold uppercase tracking-wider">Edge Config</h3>
        <button onClick={onClose} className="text-muted-foreground hover:text-foreground">
          <X className="h-4 w-4" />
        </button>
      </div>
      <div className="p-4 space-y-4">
        <div>
          <label className="text-xs font-medium text-muted-foreground mb-1 block">Label</label>
          <input
            type="text"
            value={label}
            onChange={(e) => onUpdate({ label: e.target.value })}
            placeholder="e.g. routine, urgent"
            className="w-full rounded-md border border-input bg-transparent px-3 py-1.5 text-sm shadow-sm placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-ring"
          />
        </div>
        <div>
          <label className="text-xs font-medium text-muted-foreground mb-1 block">Condition Expression</label>
          <textarea
            value={condition}
            onChange={(e) => onUpdate({ condition: e.target.value })}
            placeholder="e.g. state.priority === 'urgent'"
            rows={3}
            className="w-full rounded-md border border-input bg-transparent px-3 py-1.5 text-sm shadow-sm placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-ring font-mono text-xs"
          />
          <p className="mt-1 text-[10px] text-muted-foreground">
            JavaScript expression evaluated against agent state. Used for router edge routing.
          </p>
        </div>
        <div className="pt-2 border-t border-border">
          <Button variant="destructive" size="sm" onClick={onDelete} className="w-full text-xs">
            Delete Edge
          </Button>
        </div>
      </div>
    </div>
  );
}
